import './PageBanner.scss';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import pageBanner from '../../assets/backgroundImages/page-banner-2.png';
import addIcon from '../../assets/icons/add-button-icon.svg';
import { TagSaleModal } from '../TagSaleModal/TagSaleModal';

interface PageBannerProps {
  userName: string;
  title?: string;
  subtitle?: string;
  showTagSaleButton?: boolean;
  className?: string;
  userData: {
    companyInformations: {
      companyName: string;
    };
  };
}

export const PageBanner: React.FC<PageBannerProps> = ({ 
  userName,
  title,
  subtitle,
  showTagSaleButton = true,
  className = '',
  userData
}) => {
  const { t } = useTranslation('home');
  const [isTagSaleModalOpen, setIsTagSaleModalOpen] = useState(false);
  return (
    <div className={`page-banner ${className}`.trim()}>
      <div className="page-banner__overlay" />
      <img 
        src={pageBanner} 
        alt="" 
        className="page-banner__background" 
      />
      <div className="page-banner__content">
        <div className="page-banner__text">
          <h1 className="page-banner__title">{title || t('banner.greeting', { userName })}</h1>
          <p className="page-banner__subtitle">{subtitle || t('banner.welcomeBack')}</p>
        </div>
        {showTagSaleButton && (
          <>
            <button 
              className="page-banner__button"
              onClick={() => setIsTagSaleModalOpen(true)}
            >
              <img className="page-banner__button-icon" src={addIcon} alt="Add Icon" />
              {t('banner.tagSaleButton')}
            </button>
            <TagSaleModal 
              isOpen={isTagSaleModalOpen}
              onClose={() => setIsTagSaleModalOpen(false)}
              userData={userData}
            />
          </>
        )}
      </div>
    </div>
  );
};
